import {useMemo} from 'react';

import {FormSection} from '../../../../../../components/FormMaker/types';
import {ApplicantProfile} from '../../../types';

export const useLanguagesSection = (profile: ApplicantProfile): FormSection[] => {
  return useMemo<FormSection[]>(
    () => [
      {
        type: 'languages',
        data: {
          name: 'languages',
          initialValue: profile.languages,
        },
      },
    ],
    [profile.languages]
  );
};
